import { axios } from '@/lib/axios';

export const completeTransaction = async (id: string) => {
  axios.post('/payment/complete', null, { params: { id } }).then((response: any) => {
    window.location.href = `/payment/confirmation/${response}`;
  });
};
